module.exports = __webpack_public_path__ + "img/Weapon_197.2473995d.png";